export const GOOGLE_REVIEWS_URL = 'https://www.google.com/maps/place/Speak+English+Now/@41.540229,2.4430021,17z/data=!4m8!3m7!1s0x12a4a32c886ae953:0xda585f07d308d3f!8m2!3d41.540229!4d2.4430021!9m1!1b1!16s%2Fg%2F1w9351s9';

// Textos adaptados de reseñas públicas; cada tarjeta enlaza al texto íntegro original.
export const googleReviews = [
  {
    name: 'L M C',
    text: 'Su hijo lleva un año asistiendo a las clases, va muy contento y las sesiones se le hacen amenas. La familia quiere continuar.',
    url: 'https://maps.app.goo.gl/QUmfg2iVn7r5g4E77',
    avatar: '/media/reviews/lmc.png',
  },
  {
    name: 'María Olmedilla',
    text: 'Sus hijos, de 10 y 6 años, han ganado fluidez y comprensión. Destaca la calidad de los profesores que les han acompañado y lo contentos que han estado con cada uno de ellos.',
    url: 'https://maps.app.goo.gl/G9g5zBLzT1EKuNE77',
    avatar: '/media/reviews/maria-olmedilla.png',
  },
  {
    name: 'felipe garcia',
    text: 'Sus hijos disfrutan las clases con Liz. Explica que aprenden a escuchar y hablar inglés mediante juegos y actividades variadas, sin que las sesiones resulten pesadas. Recomienda la experiencia.',
    url: 'https://maps.app.goo.gl/3QXvMRfXMCTaDAB68',
    avatar: '/media/reviews/felipe-garcia.png',
  },
  {
    name: 'elisenda eixarch',
    text: 'Valora la comodidad de las clases a domicilio y su adaptación a cada alumno. Destaca que los niños practican comprensión y expresión en conversaciones naturales, sin depender de fichas ni libros.',
    url: 'https://maps.app.goo.gl/M68TznWSJN26r6Kn7',
    avatar: '/media/reviews/elisenda-eixarch.png',
  },
  {
    name: 'Fco Manuel García Muriel',
    text: 'Encontró en las clases online flexibilidad y más práctica oral que en su experiencia con academias tradicionales. Valora la variedad de las sesiones y el trabajo de los profesores para mejorar su fluidez y precisión.',
    url: 'https://maps.app.goo.gl/M62G76uW4BkhxyQk7',
    avatar: '/media/reviews/fco-manuel.png',
  },
  {
    name: 'Mar Molina Garcia',
    text: 'Aunque al principio tenían dudas, considera que continuar el aprendizaje de inglés de su hija con Speak English Now fue una gran decisión. Destaca a la profesora, las clases online y el trato recibido.',
    url: 'https://maps.app.goo.gl/aaUKNGBVX67xKg4R6',
    avatar: '/media/reviews/mar-molina.png',
  },
];
